import { I18nService } from '../../i18n/I18nService';
import { I18N_KEYS } from '../../i18n/keys';

export class EmergencyBanner {
  private i18n: I18nService;
  private element: HTMLElement | null = null;

  onRetry: (() => void) | null = null;

  constructor(i18n: I18nService) {
    this.i18n = i18n;
  }

  show(): void {
    if (this.element) return;

    this.element = document.createElement('div');
    this.element.id = 'emergency-banner';
    this.element.className = 'banner banner--emergency';
    this.element.setAttribute('role', 'alert');
    this.element.innerHTML = `
      <span class="banner__icon">⚠️</span>
      <div class="banner__content">
        <strong>${this.i18n.t(I18N_KEYS.EMERGENCY_TITLE)}</strong>
        <p>${this.i18n.t(I18N_KEYS.EMERGENCY_MESSAGE)}</p>
      </div>
      <button class="banner__btn" type="button">${this.i18n.t(I18N_KEYS.EMERGENCY_RETRY)}</button>
    `;

    this.element.querySelector('.banner__btn')?.addEventListener('click', () => {
      if (this.onRetry) this.onRetry();
    });

    document.body.prepend(this.element);
  }

  hide(): void {
    if (this.element) {
      this.element.remove();
      this.element = null;
    }
  }

  isVisible(): boolean {
    return this.element !== null;
  }
}
